import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "p-button-sort-base__text" }
const _hoisted_2 = {
  key: 0,
  class: "p-button-sort-base__icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    style: _normalizeStyle({ width: _ctx.width }),
    class: "p-button-sort-base"
  }, [
    _createElementVNode("span", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    (_ctx.$slots.icon)
      ? (_openBlock(), _createElementBlock("i", _hoisted_2, [
          _renderSlot(_ctx.$slots, "icon", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 4))
}